import { Box ,Image} from '@chakra-ui/react'
import React from 'react'

export default function Dashboard() {
  return (
    <Box>
        <Image src="https://assets.website-files.com/5d55f1425cb6b7a18aa77528/60ad548421171b59d3dec8b7_dash.png"/>
    </Box>
  )
}
